// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"SnapshotsList_listContainer__2SQLQ"};